import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { EllipsisVerticalIcon, PlusIcon, MegaphoneIcon } from "@heroicons/react/24/solid";
import Flyout, { useFlyout } from "components/Flyout/Flyout";
import { useSession } from "contexts";
import ScreenShot from 'assets/images/announcement.jpg';
import { useContext, useState } from "react";
import { OrgSubtypes } from "utils/orgTypes";
import New from "./New/index";
import { useQuery } from "@apollo/client";
import { GetAnnouncementsDocument } from "graphql/generated";
import AnnouncementEntry from "./Components/AnnouncementEntry";
import { AbilityContext } from "contexts/AbilityContext";
import { permissionHandler } from "utils/PermissionHandler";
import Card from "components/Card/Card";
import Button from "components/Button/Button";
import { useNavigate } from "react-router-dom";
import Header from "components/Header/Header";
import SimpleSearch from "components/SimpleSearch/SimpleSearch";
import ThumbButton from "components/ThumbButton/ThumbButton";

const Announcements = function() {
  const { flyoutProps, closeFlyout, updateFlyout } = useFlyout();
  const { organizationSubtype, organizationId, user } = useSession();
  const ability = useContext(AbilityContext);
  const navigate = useNavigate();
  const [ query, setQuery ] = useState('');
  const { data: { announcements } = {}, refetch } = useQuery(GetAnnouncementsDocument, {
    variables: {
      where: {
        organizationId: { equals: organizationId },
        OR: [
          { active: { equals: true } },
          { active: { equals: false }, creatorId: { equals: user.userOrganizationProfileId } }
        ]
      }
    },
    fetchPolicy: 'network-only'
  });
  return(
    <>
      <Flyout {...flyoutProps} />
      <div className="flex flex-col">
        {/* Title */}
        <Header title="Announcements" icon={MegaphoneIcon}>
          <div className="flex justify-end gap-2 flex-wrap order-2 lg:order-3">
            {
            permissionHandler('Create Announcement', ability) &&
              <>
                <button
                  onClick={()=> updateFlyout({ title: 'New Announcements', content: <New closeFlyout={()=>{closeFlyout();refetch();}} /> })}
                  className="hidden md:flex items-center bg-brand text-white border border-brand text-sm text-wrap rounded font-semibold py-1.5 px-4"
                >
                  <PlusIcon className="h-4 w-4 mr-1 -ml-1" />
                  <span className="lg:hidden inline">Create</span>
                  <span className="hidden lg:inline">New Announcement</span>
                </button>
                <ThumbButton size="primary" role="add" onClick={()=> updateFlyout({ title: 'New Announcements', content: <New closeFlyout={()=>{closeFlyout();refetch();}} /> })}/>
              </>
            }
          </div>
          <SimpleSearch query={query} setQuery={setQuery} className="mt-2 pt-2 border-t border-slate-200 w-full order-3 lg:order-2 lg:mt-0 lg:mr-2 lg:pt-0 lg:border-t-0 lg:w-auto" />
        </Header>
        {/* Content */}
        { organizationSubtype === OrgSubtypes.MULTI ? <>
          { announcements?.length !== 0 ? <div className="grid md:grid-cols-2 gap-2 grid-cols-1">
            { [...(announcements ??[])]?.sort( (a, b) => Number(b.pinned) - Number(a.pinned) )?.map((announcement) => (
              <AnnouncementEntry key={announcement.id} {...announcement} updatedAt={announcement.updatedAt} />
            ))}
          </div> :
            <div className="flex flex-col items-center justify-center p-10 bg-white border border-slate-300 rounded">
              <h1 className="text-xl text-slate-500">No Announcements</h1>
              <h2 className="text-slate-500">Create a new announcement to get started.</h2>
            </div>
          }
        </> : <>
          <Card>
              <h1 className="text-center text-3xl font-bold text-brand-dark">Try Our Multi-Pilot Plan</h1>
              <h2 className="text-center text-xl font-semibold text-slate-400">Sending Announcements to all your users is available on our Multi Pilot plan</h2>
              <div className='flex flex-col justify-center my-8 gap-7'>
                <img className="max-h-[26rem] mx-auto" src={ScreenShot} alt="" />
                <Button text="UPGRADE NOW" color="navy" size="sm" onClick={ () => navigate('/account/settings?settingsTab=Billing') } />
              </div>
            </Card>
        </>}
      </div>
    </>
  );
}

export default Announcements;